import React from "react";
import "./blocks.scss"
import { cssUrl } from "../../tools/Utils";

export class ImageBlock extends React.Component
{
	
	wrapper = React.createRef();
	addBg = (bg) =>
	{
		return {backgroundImage:`url(${cssUrl(bg)})`};
	}

	getWrapper()
	{
		return this.wrapper.current;
	}

	render()
	{
		let { className="", src, style={}, children, overlay, ...props} = this.props;
		className+=" image-block";
		style = {...style, ...this.addBg(src)};
		return (
			<div ref={this.wrapper} className={className}  {...props} >
				<div className="bg" style={style} > </div>
				{overlay&& <div className="overlay"> </div> }
				<div className="row">
				{children}
				</div>
			</div>
		);
	}
}